export default function DynamicSelectField({field, value, onFieldChange, error}) {
    return <div>
        <label className="block text-x font-medium mb-1" htmlFor={field.code}>
            {field.name} {field.required && (<span className="text-red-600">*</span>)}
        </label>
        <select
            onChange={onFieldChange}
            value={value}
            className={`w-full h-10 border rounded-lg px-3 py-2 focus:outline-none focus:ring-2
            ${error
                ? "border-red-500 focus:ring-red-400"
                : "border-gray-300 focus:ring-[#2f855a]"
            }`}
            id={field.code}>
            <option></option>
            {field.values.map((option) => (
                <option key={option} value={option}>{option}</option>
            ))}
        </select>

        {error && (
            <div className="text-red-600 text-sm mt-1">
                {error}
            </div>
        )}

    </div>

}